export default __webpack_public_path__ + "static/media/LEVEL18.4053dbc6.png";